import { useTranslation } from "react-i18next";

import ProgressionModal from "../../../theme/ProgressionBuilder/ProgressionModal";
import ProgressionWrapper from "../../../theme/ProgressionBuilder/ProgressionWrapper";
import { useAddProductMutation } from "../../../../newapi/warehouse/productSlice";
import Details from "./views/Details";
import DimensionsAndWeight from "./views/DimensionsAndWeight";
import { useGetSettingsForRelationQuery } from "../../../../newapi/global/generalApiSlice";
import { useSelector } from "react-redux";
import { ENV_TYPES } from "../../Sidebar";
import { relationCanEditProductDimensions } from "../../../../utils/relationProductDimensions";

const MpAddProduct = (props) => {
    const {t} = useTranslation();

    const onSave = () => {
        props.handleClose();
    }

    const selectedEnvironmentType = useSelector((state) => state.settings.environment.selectedEnvironmentType);

    const isRelation = selectedEnvironmentType === ENV_TYPES[200];
    const {data: relationSettings, isLoading: isLoadingSettings} = useGetSettingsForRelationQuery();

    const isRelationEditProductDimensionsDisabled = isRelation && !isLoadingSettings &&
    !relationCanEditProductDimensions(relationSettings);

    if(isRelationEditProductDimensionsDisabled) {
        return (
            <ProgressionModal
                open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper onSave={onSave} query={useAddProductMutation} isModal title={t("add_product")}>
                <Details isRelationEditProductDimensionsDisabled={isRelationEditProductDimensionsDisabled}/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
    }

    return (
        <ProgressionModal
            open={props.open}
            onClose={props.handleClose}
        >
            <ProgressionWrapper onSave={onSave} query={useAddProductMutation} isModal title={t("add_product")}>
            <Details isRelationEditProductDimensionsDisabled={isRelationEditProductDimensionsDisabled}/>
                <DimensionsAndWeight/>
            </ProgressionWrapper>
        </ProgressionModal>
    )
}

export default MpAddProduct;